import APIClient from '@/shared/http/clients/api'
import APIClientUpload from '@/shared/http/clients/apiupload'

const resourceName = 'REGroupImage'
const APIBusinessCommon = process.env.APIBaseURLRealEstate

const GetAllByOccourenceId = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetAllByOccourenceId/${id}`, data, config)
const SaveGroup = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/SaveGroup`, data, config)
const SendFileArquivo = (occourenceid, data = {}, config = {}) => APIClientUpload.post(`${APIBusinessCommon}/${resourceName}/SendFileArquivo/${occourenceid}`, data, config)

const GroupImageRepository = {
  GetAllByOccourenceId,
  SaveGroup,
  SendFileArquivo

}

export default GroupImageRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/groupimage.js